import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'main',
    children: [
      {
        path: '',
        loadChildren: () => import('../pages/main/main.module').then(m => m.MainPageModule),
      },
    ]
  },
  {
    path: 'auth',
    children: [
      {
        path: 'login',
        loadChildren: () => import('../pages/login/login.module').then(m => m.LoginPageModule),
      },
      {
        path: 'recoverPassword',
        loadChildren: () => import('../pages/recoverPassword/recoverPassword.module').then(m => m.RecoverPasswordPageModule),
      },
      {
        path: 'resetPassword/:token',
        loadChildren: () => import('../pages/resetPasswordForm/resetPasswordForm.module').then(m => m.ResetPasswordFormPageModule),
      }
    ]
  },
  // { path: '**', redirectTo: '' }
  {
    path: '',
    redirectTo: '/main/dashboard',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
